import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = t.marquee;
  const sequence = [...items, ...items];

  return (
    <div
      data-testid="marquee"
      className="relative border-y gold-hairline bg-pine/40 py-5 overflow-hidden"
      aria-hidden="false"
    >
      <div className="flex w-max animate-marquee will-change-transform">
        {[0, 1].map((dup) => (
          <div
            key={dup}
            aria-hidden={dup === 1}
            className="flex shrink-0 items-center"
          >
            {sequence.map((item, i) => (
              <span
                key={`${dup}-${i}`}
                className="flex items-center font-mono text-[0.6rem] sm:text-xs uppercase tracking-[0.35em] text-gold/80 whitespace-nowrap"
              >
                <span className="px-8">{item}</span>
                <span className="text-gold/40 text-[0.5rem]">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
